/* ───────────────────────────────────────────────────────────────────────────
 * Header search autocomplete.
 * Attaches to .site-search__form, reads its data-suggest-url, and renders a
 * type-ahead dropdown of product suggestions fetched from the theme's own
 * search view (templates/search.suggest.liquid → JSON).
 * Progressive enhancement: if JS fails the form still submits to /search.
 * ─────────────────────────────────────────────────────────────────────────── */
(function () {
  var form = document.querySelector('.site-search__form');
  if (!form) return;
  var input = form.querySelector('.site-search__input');
  var endpoint = form.getAttribute('data-suggest-url');
  if (!input || !endpoint) return;

  var box = document.createElement('div');
  box.className = 'site-search__suggestions';
  box.setAttribute('role', 'listbox');
  box.hidden = true;
  form.appendChild(box);

  var items = [];      // suggestion anchor nodes, for keyboard nav
  var active = -1;
  var lastQ = '';
  var timer = null;
  var controller = null;

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function close() {
    box.hidden = true;
    box.innerHTML = '';
    items = [];
    active = -1;
    input.setAttribute('aria-expanded', 'false');
  }

  function setActive(i) {
    items.forEach(function (n, idx) { n.classList.toggle('is-active', idx === i); });
    active = i;
    if (items[i]) items[i].scrollIntoView({ block: 'nearest' });
  }

  function render(data) {
    var products = (data && data.products) || [];
    var html = '';
    if (!products.length) {
      box.innerHTML = '<div class="site-search__suggestions-empty">Inga förslag</div>';
      box.hidden = false;
      items = [];
      active = -1;
      input.setAttribute('aria-expanded', 'true');
      return;
    }
    products.forEach(function (p) {
      html += '<a class="site-search__suggestion" role="option" href="' + p.url + '">'
        + (p.image
            ? '<img class="site-search__suggestion-img" src="' + p.image + '" alt="" loading="lazy" width="44" height="44">'
            : '<span class="site-search__suggestion-img site-search__suggestion-img--ph"></span>')
        + '<span class="site-search__suggestion-text">'
        +   '<span class="site-search__suggestion-title">' + escapeHtml(p.title) + '</span>'
        +   (p.vendor ? '<span class="site-search__suggestion-meta">' + escapeHtml(p.vendor) + '</span>' : '')
        + '</span>'
        + (p.price ? '<span class="site-search__suggestion-price">' + escapeHtml(p.price) + '</span>' : '')
        + '</a>';
    });
    if (data.viewAllUrl) {
      html += '<a class="site-search__suggestion site-search__suggestion--all" role="option" href="' + data.viewAllUrl + '">'
        + 'Visa alla träffar för ”' + escapeHtml(data.q) + '” →</a>';
    }
    box.innerHTML = html;
    items = Array.prototype.slice.call(box.querySelectorAll('.site-search__suggestion'));
    box.hidden = false;
    active = -1;
    input.setAttribute('aria-expanded', 'true');
  }

  function fetchSuggest(q) {
    if (controller) { try { controller.abort(); } catch (e) {} }
    controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var opts = controller ? { signal: controller.signal } : {};
    fetch(endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(q), opts)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data && input.value.trim() === q) render(data); })
      .catch(function () { /* aborted or network error — ignore */ });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (q.length < 2) { close(); lastQ = ''; return; }
    if (q === lastQ) return;
    lastQ = q;
    clearTimeout(timer);
    timer = setTimeout(function () { fetchSuggest(q); }, 180);
  });

  input.addEventListener('keydown', function (e) {
    if (box.hidden || !items.length) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive((active + 1) % items.length); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((active - 1 + items.length) % items.length); }
    else if (e.key === 'Enter') {
      if (active >= 0 && items[active]) { e.preventDefault(); window.location.href = items[active].getAttribute('href'); }
    } else if (e.key === 'Escape') { close(); }
  });

  input.addEventListener('focus', function () {
    if (items.length && input.value.trim().length >= 2) box.hidden = false;
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) close();
  });
})();
